import React, { Component } from 'react';
import { Link, animateScroll as scroll } from "react-scroll";

export default class MainNav extends Component {

  scrollToTop = () => {
    scroll.scrollToTop();
  };

  constructor() {
    super();
    this.state = {
      show: false,
    }
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  toggleMenu() {
    this.setState((menuBlade) => {
      return {
        ...menuBlade,
        show: !menuBlade.show
      }
    })
  }
  
  render() {
    return (
      <div className={(this.state.show ? 'show-blade' : '')}>
        <nav className='main-nav flex-group flex-align-center flex-start flex-nowrap' onClick={this.toggleMenu}>
          <div className='material-icons'>
            <span>menu</span>
            <span>menu_open</span>
          </div>
          <h3>
            <span>Menu</span>
            <span>Close</span>
          </h3>
        </nav>

        <article className='blade'>
          <nav>
            <ul>
              <li>
                <Link 
                  to='home' 
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
                  className='flex-group flex-start flex-align-center'
                  onClick={this.scrollToTop}
                >
                  <span className='material-icons-outlined'>home</span>
                  <h2>Home</h2>
                </Link>
              </li>
              <li className='flex-group flex-start flex-align-center'>
                <Link 
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
                  to='tech' 
                  className='flex-group flex-start flex-align-center'
                >
                  <span className='material-icons-outlined'>sailing</span>
                  <h2>Tech Spec</h2>
                </Link>
                <p>
                  Feast your eyes on our new ODC 48 Catamaran. A very 
                  modern and aesthetic design that's bursting 
                  with state-of-the-art features
                </p>
              </li>
              <li className='flex-group flex-start flex-align-center'>
                <Link 
                  spy={true}
                  smooth={true}
                  offset={-70}
                  duration={1000}
                  to='contact' 
                  className='flex-group flex-start flex-align-center'
                >
                  <span className='material-icons-outlined'>help_outline</span>
                  <h2>Contact</h2>
                </Link>
                <p>
                  Please get in contact with us. A member of our sales
                  team will be there to assist you with any information that 
                  you require
                </p>
              </li>
            </ul>
          </nav>
        </article>
      </div>
    );
  }
}